import { render } from "./NewClaimDetail.vue?vue&type=template&id=20241497"
import script from "./NewClaimDetail.vue?vue&type=script&lang=js"
export * from "./NewClaimDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__